module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.012cf6a1.012cf6a.woff";


//////////////////
// WEBPACK FOOTER
// ./~/geetest-ui/fonts/MaterialIcons-Regular.012cf6a1.woff
// module id = 460
// module chunks = 14